import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

const Wrapper = styled.div`
  color: white;
  margin: 0 50px 75px;
  padding-top: 135px;
  position: relative;


  &:before {
    background: ${theme.colors.primary};
    bottom: 13%;
    content: "";
    display: block;
    height: 87%;
    left: -50px;
    position: absolute;
    width: 100vw;
  };

  ${media.lg`
  &:before {
    background: ${theme.colors.primary};
    bottom: 25%;
    content: "";
    display: block;
    height: 75%;
    left: -50px;
    position: absolute;
    width: 100vw;
  };
  `}
  
  ${media.xs`
    margin: 0 20px;

    &:before {
      height: 80%;
      top: 0;
      left: -20px;
      bottom: auto;
    }
  `}
`

const Grid = styled.div`
  display: grid;
  grid-auto-rows: 45px minmax(max-content, min-content);
  grid-template-columns: repeat(12, 1fr);

  ${media.xs`
    grid-auto-rows: minmax(max-content, min-content);
    grid-template-columns: repeat(4, 1fr);
  `}
`

const Line = styled.div`
  border-bottom: 1px solid white;
  grid-column: 1 / span 12;
  grid-row: 1;
  z-index: 1;

  ${media.xs`
    grid-column: 1 / span 4;
  `}
`

const TextContainer = styled.div`
  grid-column: 1 / span 3;
  grid-row: 2;
  z-index: 2;

  ${media.xs`
    grid-column: 1 / span 4;
  `}
`

const Title = styled.h1`
  font-size: 20px;
  font-weight: 300;
  line-height: 26px;
${media.lg`
font-size: 40px;
font-weight: 300;
line-height: 60px;
`}
  ${media.xs`
    font-size: 35px;
    line-height: 38px;
  `}
`

const CallToAction = styled.p`
  font-size: 12px;
  margin-top: 35px;
  text-transform: uppercase;
`

const ImageContainer = styled.div`
  grid-column: 4 / span 9;
  grid-row: 2;
  z-index: 1;
  height: 0;
  padding-bottom: 55%;
  overflow: hidden;
  margin-top: -45px;
  position: relative;

  ${media.xs`
    grid-column: 1 / span 4;
    grid-row: 3;
    margin-top: 0;
    padding-bottom: 0;
    overflow: auto;
    height: auto;
  `}
`

const Image = styled.img`
  display: block;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);

  ${media.xs`
    position: relative;
    top: auto;
    transform: none;
  `}
`

export default class index extends Component {
  render() {
    const { cta, title, image } = this.props
    const sourceUrl = image && image.sourceUrl

    return (
      <Wrapper>
        <Grid>
          <Line />
          <TextContainer>
            <CallToAction>{cta}</CallToAction>
            <Title>{title}</Title>
          </TextContainer>
          <ImageContainer>
            <Image src={sourceUrl} />
          </ImageContainer>
        </Grid>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Header/index.js